import usePagination from '@/hooks/usePagination';
import { OrderEnum, StatusApplicableOnEnum, StatusesFilters } from '@/types/schema';

import { useStatusesQuery } from '../../graphql/queries/generated/statuses';

export const APPLICABLE_ON_FILTER = [StatusApplicableOnEnum.Task];

export const SORT_BY = { field: 'order', order: OrderEnum.Asc };

function useStatuses({
  generatedBy,
  entityIds,
  pause,
  excludeEntityStatuses,
  statusIds,
}: Pick<StatusesFilters, 'generatedBy' | 'entityIds' | 'excludeEntityStatuses' | 'statusIds'> & {
  pause?: boolean;
}) {
  const { data, error, isFetching } = usePagination(
    useStatusesQuery,
    {
      filters: {
        applicableOn: APPLICABLE_ON_FILTER,
        generatedBy,
        entityIds,
        excludeEntityStatuses,
        statusIds,
      },
      sort: SORT_BY,
    },
    { edgeKey: 'statuses', pause },
  );

  return { statuses: data, error, isFetching };
}

export default useStatuses;
